if (!customElements.get('inspiration-cart-form')) {
  customElements.define(
    'inspiration-cart-form',
    class InspirationCartForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('.mc-insp-submit__text');
        this.spinner = this.querySelector('.loading__spinner');
        this.errorEl = this.querySelector('.mc-insp-error');
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.i18n = JSON.parse(this.dataset.i18n || '{}');
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      onSubmit(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const items = this.collectItems();
        if (items.length === 0) {
          this.showError(this.i18n.selectAtLeastOne);
          return;
        }
        this.hideError();
        this.setLoading(true);

        // Použijeme /cart/add.js — garantuje JSON odpověď
        const cartAddUrl = (window.routes?.cart_add_url || '/cart/add').replace(/\.js$/, '').replace(/\/?$/, '') + '.js';

        fetch(cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items }),
        })
          .then((r) => r.json())
          .then((response) => {
            if (response.status) {
              this.showError(response.description || this.i18n.addToCartFailed);
              return;
            }
            // Úspěch — zobraz feedback v tlačítku
            this.showSuccess();

            // Notify Dawn pub/sub → aktualizuje ikonku košíku
            try {
              if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'inspiration-cart-form', cartData: response });
              }
            } catch (e) { /* noncritical */ }
            // Otevři cart drawer s čerstvým obsahem
            if (this.cart) {
              fetch(`${window.location.pathname}?section_id=cart-drawer`)
                .then((r) => r.text())
                .then((html) => {
                  const doc = new DOMParser().parseFromString(html, 'text/html');
                  const inner = doc.querySelector('.shopify-section');
                  const target = document.querySelector('#CartDrawer');
                  if (inner && target) target.innerHTML = inner.innerHTML;
                  this.cart.classList.remove('is-empty');
                  this.cart.open(this.submitButton);
                })
                .catch(() => {});
            }
          })
          .catch((err) => {
            console.error('[inspiration cart]', err);
            this.showError(this.i18n.addToCartError);
          })
          .finally(() => this.setLoading(false));
      }

      collectItems() {
        const rows = this.querySelectorAll('.mc-insp-row');
        const items = [];
        rows.forEach((row) => {
          const checkbox = row.querySelector('.mc-insp-row__checkbox');
          if (!checkbox || !checkbox.checked) return;
          const variantInput = row.querySelector('.mc-insp-variant');
          if (!variantInput) return;
          const variantId = parseInt(variantInput.value, 10);
          const qtyInput = row.querySelector('.mc-insp-qty-input');
          const quantity = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10)) : 1;
          if (variantId) items.push({ id: variantId, quantity });
        });
        return items;
      }

      setLoading(on) {
        this.submitButton.setAttribute('aria-disabled', on ? 'true' : 'false');
        this.submitButton.classList.toggle('loading', on);
        this.spinner.classList.toggle('hidden', !on);
        this.submitButtonText.classList.toggle('hidden', on);
      }

      showSuccess() {
        const doneEl = this.querySelector('.mc-insp-submit__done');
        this.submitButtonText.hidden = true;
        if (doneEl) doneEl.hidden = false;
        this.submitButton.classList.add('mc-insp-submit--done');
        setTimeout(() => {
          this.submitButtonText.hidden = false;
          if (doneEl) doneEl.hidden = true;
          this.submitButton.classList.remove('mc-insp-submit--done');
        }, 3000);
      }

      showError(msg) { this.errorEl.textContent = msg; this.errorEl.hidden = false; }
      hideError() { this.errorEl.hidden = true; }
    }
  );
}

if (!customElements.get('inspiration-gallery')) {
  customElements.define(
    'inspiration-gallery',
    class InspirationGallery extends HTMLElement {
      connectedCallback() {
        this.i18n = JSON.parse(this.dataset.i18n || '{}');
        this.cards       = Array.from(this.querySelectorAll('[data-project]'));
        this.checks      = Array.from(this.querySelectorAll('input[data-filter-key][data-filter-value]'));
        this.searchInput = this.querySelector('[data-search-input]');
        this.sortSelect  = this.querySelector('[data-sort-select]');
        this.grid        = this.querySelector('.mc-gallery-grid');
        this.activePanel = this.querySelector('[data-active-filters]');
        this.clearBtn    = this.querySelector('[data-clear-filters]');
        this.emptyState  = this.querySelector('.mc-gallery-empty[hidden]');
        this.toggleBtn   = this.querySelector('[data-filter-toggle]');
        this.sidebar     = this.querySelector('[data-sidebar]');

        // Známé facet klíče (z checkboxů) — jen tyto čteme z URL
        this.keys = [...new Set(this.checks.map((c) => c.dataset.filterKey))];

        // Stav: facetKey -> Set vybraných hodnot; search zvlášť
        this.facets = {};
        this.search = '';

        // Obnova z URL
        const params = new URLSearchParams(window.location.search);
        this.keys.forEach((k) => {
          const raw = params.get(k);
          if (raw) this.facets[k] = new Set(raw.split(',').filter(Boolean));
        });
        if (params.get('search')) this.search = params.get('search');

        // Řazení (výchozí: doporučené = pole „Pořadí")
        this.sort = params.get('sort') || 'recommended';

        // Napojení checkboxů + sync stavu
        this.checks.forEach((chk) => {
          const set = this.facets[chk.dataset.filterKey];
          chk.checked = !!(set && set.has(chk.dataset.filterValue));
          chk.addEventListener('change', () => this.onCheck(chk));
        });

        // Otevři facety, které mají aktivní filtr (aby zákazník hned viděl výběr)
        this.querySelectorAll('[data-facet]').forEach((facet) => {
          if (this.facets[facet.dataset.facet]) facet.open = true;
        });

        // Hledání
        if (this.searchInput) {
          if (this.search) this.searchInput.value = this.search;
          this.searchInput.addEventListener('input', () => {
            this.search = this.searchInput.value.trim();
            this.sync();
          });
        }

        // Řadicí dropdown
        if (this.sortSelect) {
          this.sortSelect.value = this.sort;
          this.sortSelect.addEventListener('change', () => {
            this.sort = this.sortSelect.value;
            this.updateURL();
            this.sortCards();
          });
        }

        // Vymazat vše
        if (this.clearBtn) this.clearBtn.addEventListener('click', () => this.clearAll());

        // Mobilní přepínač sidebaru
        if (this.toggleBtn && this.sidebar) {
          this.toggleBtn.addEventListener('click', () => this.sidebar.classList.toggle('is-open'));
        }

        this.sortCards();
        this.sync();
      }

      sortCards() {
        if (!this.grid) return;
        const name = (el) => el.dataset.projectName || '';
        const byName = (a, b) => name(a).localeCompare(name(b), 'cs');
        const diffRank = (el) => {
          const order = ['snadná', 'střední', 'náročná'];
          const i = order.indexOf((el.dataset.difficulty || '').toLowerCase());
          return i === -1 ? 999 : i;
        };
        const orderVal = (el) => {
          const n = parseInt(el.dataset.sortOrder, 10);
          return Number.isNaN(n) ? Infinity : n;
        };
        const glazeCount = (el) => parseInt(el.dataset.glazeCount || '0', 10);

        const sorted = [...this.cards].sort((a, b) => {
          switch (this.sort) {
            case 'name':       return byName(a, b);
            case 'difficulty': return diffRank(a) - diffRank(b) || byName(a, b);
            case 'glazes':     return glazeCount(a) - glazeCount(b) || byName(a, b);
            default:           return orderVal(a) - orderVal(b) || byName(a, b); // recommended
          }
        });

        // Přeskládej karty v DOM, prázdné stavy nech na konci
        sorted.forEach((card) => this.grid.appendChild(card));
        this.grid.querySelectorAll('.mc-gallery-empty').forEach((el) => this.grid.appendChild(el));
      }

      onCheck(chk) {
        const { filterKey: key, filterValue: val } = chk.dataset;
        if (!this.facets[key]) this.facets[key] = new Set();
        if (chk.checked) this.facets[key].add(val);
        else this.facets[key].delete(val);
        if (this.facets[key].size === 0) delete this.facets[key];
        this.sync();
      }

      matches(card) {
        // Fulltext — název projektu + názvy glazur
        if (this.search) {
          const q = this.search.toLowerCase();
          const name   = (card.dataset.projectName || '').toLowerCase();
          const glazes = (card.dataset.glazesText || '').toLowerCase();
          if (!name.includes(q) && !glazes.includes(q)) return false;
        }
        // Facety: v rámci facetu OR, mezi facety AND
        for (const key of Object.keys(this.facets)) {
          const selected = this.facets[key];
          if (!selected || selected.size === 0) continue;
          const cardVals = (card.dataset[key] || '')
            .toLowerCase().split(',').map((s) => s.trim()).filter(Boolean);
          let hit = false;
          for (const v of selected) {
            if (cardVals.includes(v.toLowerCase())) { hit = true; break; }
          }
          if (!hit) return false;
        }
        return true;
      }

      applyFilters() {
        let visible = 0;
        this.cards.forEach((card) => {
          const show = this.matches(card);
          card.hidden = !show;
          if (show) visible++;
        });
        if (this.emptyState) this.emptyState.hidden = visible > 0;
      }

      labelFor(key, val) {
        const chk = this.checks.find(
          (c) => c.dataset.filterKey === key && c.dataset.filterValue === val
        );
        return chk ? (chk.dataset.filterLabel || val) : val;
      }

      renderActiveTags() {
        if (!this.activePanel) return;
        const esc = (s) => String(s).replace(/"/g, '&quot;');
        const tags = [];
        const labels = this.i18n.labels || {};
        Object.keys(this.facets).forEach((key) => {
          this.facets[key].forEach((val) => {
            tags.push(`
              <span class="mc-active-tag">
                ${labels[key] || key}: <strong>${this.labelFor(key, val)}</strong>
                <span class="mc-active-tag__remove" data-remove-key="${key}" data-remove-val="${esc(val)}" role="button" aria-label="${esc(this.i18n.removeFilterAria)}">✕</span>
              </span>`);
          });
        });
        if (this.search) {
          tags.push(`
            <span class="mc-active-tag">
              ${this.i18n.searchLabel} <strong>${this.search}</strong>
              <span class="mc-active-tag__remove" data-remove-key="search" role="button" aria-label="${esc(this.i18n.removeSearchAria)}">✕</span>
            </span>`);
        }
        this.activePanel.innerHTML = tags.join('');
        this.activePanel.querySelectorAll('[data-remove-key]').forEach((el) => {
          el.addEventListener('click', () => this.removeOne(el.dataset.removeKey, el.dataset.removeVal));
        });
        if (this.clearBtn) this.clearBtn.hidden = tags.length === 0;
      }

      removeOne(key, val) {
        if (key === 'search') {
          this.search = '';
          if (this.searchInput) this.searchInput.value = '';
        } else if (this.facets[key]) {
          this.facets[key].delete(val);
          if (this.facets[key].size === 0) delete this.facets[key];
          const chk = this.checks.find(
            (c) => c.dataset.filterKey === key && c.dataset.filterValue === val
          );
          if (chk) chk.checked = false;
        }
        this.sync();
      }

      clearAll() {
        this.facets = {};
        this.search = '';
        this.checks.forEach((c) => (c.checked = false));
        if (this.searchInput) this.searchInput.value = '';
        this.sync();
      }

      updateCounts() {
        this.querySelectorAll('[data-facet]').forEach((facet) => {
          const badge = facet.querySelector('[data-facet-count]');
          if (!badge) return;
          const set = this.facets[facet.dataset.facet];
          const n = set ? set.size : 0;
          if (n > 0) { badge.textContent = n; badge.hidden = false; }
          else { badge.hidden = true; }
        });
      }

      updateURL() {
        const params = new URLSearchParams();
        Object.keys(this.facets).forEach((k) => {
          const v = [...this.facets[k]];
          if (v.length) params.set(k, v.join(','));
        });
        if (this.search) params.set('search', this.search);
        if (this.sort && this.sort !== 'recommended') params.set('sort', this.sort);
        const qs = params.toString();
        window.history.replaceState({}, '', qs ? `${window.location.pathname}?${qs}` : window.location.pathname);
      }

      sync() {
        this.updateURL();
        this.applyFilters();
        this.renderActiveTags();
        this.updateCounts();
      }
    }
  );
}

// ── Drawer ──────────────────────────────────────────────────────────────────

// Základní URL galerie — čteme z data atributu, fallback na /pages/inspirace
function _galleryUrl() {
  return document.querySelector('inspiration-gallery')?.dataset.galleryUrl || '/pages/inspirace';
}

function openDrawer(handle) {
  // Zavřít případný předchozí otevřený drawer
  document.querySelectorAll('.mc-drawer:not([hidden])').forEach(d => {
    d.hidden = true;
  });

  const drawer = document.getElementById(`drawer-${handle}`);
  if (!drawer) {
    console.warn('[inspiration] drawer not found for handle:', handle);
    return;
  }
  drawer.hidden = false;
  document.body.classList.add('overflow-hidden');
  const closeBtn = drawer.querySelector('[data-drawer-close]');
  if (closeBtn) closeBtn.focus();
  window.history.pushState({ drawer: handle }, '', `${_galleryUrl()}?p=${handle}`);
}

function closeDrawer(drawer) {
  if (!drawer) return;
  drawer.hidden = true;
  document.body.classList.remove('overflow-hidden');
  window.history.pushState({}, '', _galleryUrl());
}

document.addEventListener('click', (evt) => {
  // Open via card button
  const openBtn = evt.target.closest('[data-open-drawer]');
  if (openBtn) { openDrawer(openBtn.dataset.openDrawer); return; }

  // Close via ✕ button
  const closeBtn = evt.target.closest('[data-drawer-close]');
  if (closeBtn) { closeDrawer(closeBtn.closest('.mc-drawer')); return; }

  // Close when clicking outside the panel (on the overlay area)
  const openDrawerEl = document.querySelector('.mc-drawer:not([hidden])');
  if (openDrawerEl && !evt.target.closest('.mc-drawer__panel')) {
    closeDrawer(openDrawerEl);
    return;
  }
});

document.addEventListener('keyup', (evt) => {
  if (evt.key !== 'Escape') return;
  const open = document.querySelector('.mc-drawer:not([hidden])');
  if (open) closeDrawer(open);
});

// Open drawer from URL param on page load
(function () {
  const p = new URLSearchParams(window.location.search).get('p');
  if (p) openDrawer(p);
})();

// ── Quantity +/- buttons for inspiration rows
document.addEventListener('click', (evt) => {
  const btn = evt.target.closest('[data-qty-action]');
  if (!btn) return;
  const group = btn.closest('.mc-insp-qty-group');
  if (!group) return;
  const input = group.querySelector('.mc-insp-qty-input');
  if (!input) return;
  const min = parseInt(input.min || '1', 10);
  const max = parseInt(input.max || '99', 10);
  const delta = btn.dataset.qtyAction === 'plus' ? 1 : -1;
  input.value = Math.min(max, Math.max(min, parseInt(input.value || '1', 10) + delta));
});
